import { HTTP_CP_SmartSearchCase } from '@api-new/caseservice';
import { HTTP_CP_SmartSearch } from '@api-new/mortgageservice';
import { SmartSearchDealEntitiesModel } from '@platform/portfolio/models/smart-search-deal-entities.model';
import { PortfolioSmartSearchModel } from '@platform/smart-search/models/portfolio-smart-search.model';
import { PropertyMortgageSelectItemModel } from '@shared-lib/models/property-mortgage-select-item.model';
import { portfolioCasePreviewCardAdapter } from './portfolio-case-preview-card.adapter';

export const portfolioSmartSearchAdapter = (
  smartSearch: HTTP_CP_SmartSearch,
  smartSearchDealEntities: SmartSearchDealEntitiesModel,
  smartSearchCases: HTTP_CP_SmartSearchCase[],
  propertyMortgageSelectItems: PropertyMortgageSelectItemModel[],
): PortfolioSmartSearchModel => {
  const smartSearchDealEntity = smartSearchDealEntities[smartSearch.id];
  const smartSearchCase = smartSearchCases.find((smartSearchCase) => smartSearchCase.smartSearchId === smartSearch.id);
  const casePreviewCard = portfolioCasePreviewCardAdapter(smartSearchCase, smartSearchDealEntity?.numberOfSmartSearchDeals);

  const propertyId = smartSearch.remortgagePropertyId;
  const propertyMortgage = getPropertyMortgageByPropId(propertyId, propertyMortgageSelectItems);

  return {
    ...smartSearch,
    deals: smartSearchDealEntity?.smartSearchDeals,
    smartSearchCase,
    casePreviewCard,
    propertyMortgage,
  };
};

// ------ HELPERS -----
const getPropertyMortgageByPropId = (
  propertyId,
  propertyMortgageSelectItems: PropertyMortgageSelectItemModel[],
): PropertyMortgageSelectItemModel =>
  propertyId ? propertyMortgageSelectItems.find((propertyMortgage) => propertyMortgage.propertyId === propertyId) : null;
